const GlobalEventTypes = {
  REMOVE_ABANDON_LISTENER: 'remove-abandon-listener',
  // Event for syncing billing cycle changes across products (e.g., Zone products -> Zoom Phone)
  SYNC_PBX_STATE_WITH_BILLING_CYCLE: 'sync-pbx-state-with-billing-cycle',
}

export default GlobalEventTypes;
